export const INPUT_MAX_LENGTH = 104;
export const GRAPHIC_ORGANIZER_PARAM = "graphicOrganizer";
